module.exports = __webpack_public_path__ + "static/media/fblogo.6e48d4e3.svg";